import React from 'react';

const Single = ({ className }) => {
    return (
        <svg
            className={className}
            width={200}
            height={117}
            viewBox="0 0 200 117"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            //{...props}
        >
            <g clipPath="url(#clip0_46_1400)">
            <rect width={200} height={117} rx={6} fill="#F4F0EC" />
            <path
                d="M29 73C29 71.3431 30.3431 70 32 70H58C59.6569 70 61 71.3431 61 73V94C61 95.6569 59.6569 97 58 97H32C30.3431 97 29 95.6569 29 94V73Z"
                fill="#404040"
            />
            <path d="M35.9782 78.5H61H35.9782Z" fill="#404040" />
            <path
                d="M34 92H47"
                stroke="white"
                strokeWidth={2}
                strokeLinecap="round"
            />
            <path
                d="M55 92H56"
                stroke="#767676"
                strokeWidth={2}
                strokeLinecap="round"
            />
            <path
                d="M40.0224 80.5332L37.3762 83.519C36.5047 84.5023 37.2443 86 38.6015 86H51.3993C52.6273 86 53.3966 84.7455 52.7862 83.7382L49.7692 78.7599C49.2266 77.8647 47.9154 77.7355 47.189 78.5056L45.1387 80.6797C44.5732 81.2794 43.61 81.3559 42.9466 80.8538L42.2467 80.3241C41.5685 79.8107 40.5804 79.9035 40.0224 80.5332Z"
                fill="#818181"
            />
            <path
                d="M41 78C42.1046 78 43 77.1046 43 76C43 74.8954 42.1046 74 41 74C39.8954 74 39 74.8954 39 76C39 77.1046 39.8954 78 41 78Z"
                fill="#E66819"
            />
            <path
                d="M29 103C29 101.343 30.3431 100 32 100H58C59.6569 100 61 101.343 61 103V124C61 125.657 59.6569 127 58 127H32C30.3431 127 29 125.657 29 124V103Z"
                fill="#404040"
            />
            <path d="M35.9782 108.5H61H35.9782Z" fill="#404040" />
            <path
                d="M40.0224 110.533L37.3762 113.519C36.5047 114.502 37.2443 116 38.6015 116H51.3993C52.6273 116 53.3966 114.745 52.7862 113.738L49.7692 108.76C49.2266 107.865 47.9154 107.735 47.189 108.506L45.1387 110.68C44.5732 111.279 43.61 111.356 42.9466 110.854L42.2467 110.324C41.5685 109.811 40.5804 109.904 40.0224 110.533Z"
                fill="#818181"
            />
            <path
                d="M41 108C42.1046 108 43 107.105 43 106C43 104.895 42.1046 104 41 104C39.8954 104 39 104.895 39 106C39 107.105 39.8954 108 41 108Z"
                fill="#E66819"
            />
            <path
                d="M65 73C65 71.3431 66.3431 70 68 70H94C95.6569 70 97 71.3431 97 73V94C97 95.6569 95.6569 97 94 97H68C66.3431 97 65 95.6569 65 94V73Z"
                fill="#404040"
            />
            <path d="M71.9782 78.5H97H71.9782Z" fill="#404040" />
            <path
                d="M70 92H83"
                stroke="white"
                strokeWidth={2}
                strokeLinecap="round"
            />
            <path
                d="M91 92H92"
                stroke="#767676"
                strokeWidth={2}
                strokeLinecap="round"
            />
            <path
                d="M76.0224 80.5332L73.3762 83.519C72.5047 84.5023 73.2443 86 74.6015 86H87.3993C88.6273 86 89.3966 84.7455 88.7862 83.7382L85.7692 78.7599C85.2266 77.8647 83.9154 77.7355 83.189 78.5056L81.1387 80.6797C80.5732 81.2794 79.61 81.3559 78.9466 80.8538L78.2467 80.3241C77.5685 79.8107 76.5804 79.9035 76.0224 80.5332Z"
                fill="#818181"
            />
            <path
                d="M77 78C78.1046 78 79 77.1046 79 76C79 74.8954 78.1046 74 77 74C75.8954 74 75 74.8954 75 76C75 77.1046 75.8954 78 77 78Z"
                fill="#E66819"
            />
            <path
                d="M65 103C65 101.343 66.3431 100 68 100H94C95.6569 100 97 101.343 97 103V124C97 125.657 95.6569 127 94 127H68C66.3431 127 65 125.657 65 124V103Z"
                fill="#404040"
            />
            <path d="M71.9782 108.5H97H71.9782Z" fill="#404040" />
            <path
                d="M76.0224 110.533L73.3762 113.519C72.5047 114.502 73.2443 116 74.6015 116H87.3993C88.6273 116 89.3966 114.745 88.7862 113.738L85.7692 108.76C85.2266 107.865 83.9154 107.735 83.189 108.506L81.1387 110.68C80.5732 111.279 79.61 111.356 78.9466 110.854L78.2467 110.324C77.5685 109.811 76.5804 109.904 76.0224 110.533Z"
                fill="#818181"
            />
            <path
                d="M77 108C78.1046 108 79 107.105 79 106C79 104.895 78.1046 104 77 104C75.8954 104 75 104.895 75 106C75 107.105 75.8954 108 77 108Z"
                fill="#E66819"
            />
            <path
                d="M139 73C139 71.3431 140.343 70 142 70H168C169.657 70 171 71.3431 171 73V94C171 95.6569 169.657 97 168 97H142C140.343 97 139 95.6569 139 94V73Z"
                fill="#404040"
            />
            <path d="M145.978 78.5H171H145.978Z" fill="#404040" />
            <path
                d="M144 92H157"
                stroke="white"
                strokeWidth={2}
                strokeLinecap="round"
            />
            <path
                d="M165 92H166"
                stroke="#767676"
                strokeWidth={2}
                strokeLinecap="round"
            />
            <path
                d="M150.022 80.5332L147.376 83.519C146.505 84.5023 147.244 86 148.601 86H161.399C162.627 86 163.397 84.7455 162.786 83.7382L159.769 78.7599C159.227 77.8647 157.915 77.7355 157.189 78.5056L155.139 80.6797C154.573 81.2794 153.61 81.3559 152.947 80.8538L152.247 80.3241C151.568 79.8107 150.58 79.9035 150.022 80.5332Z"
                fill="#818181"
            />
            <path
                d="M151 78C152.105 78 153 77.1046 153 76C153 74.8954 152.105 74 151 74C149.895 74 149 74.8954 149 76C149 77.1046 149.895 78 151 78Z"
                fill="#E66819"
            />
            <path
                d="M139 103C139 101.343 140.343 100 142 100H168C169.657 100 171 101.343 171 103V124C171 125.657 169.657 127 168 127H142C140.343 127 139 125.657 139 124V103Z"
                fill="#404040"
            />
            <path d="M145.978 108.5H171H145.978Z" fill="#404040" />
            <path
                d="M150.022 110.533L147.376 113.519C146.505 114.502 147.244 116 148.601 116H161.399C162.627 116 163.397 114.745 162.786 113.738L159.769 108.76C159.227 107.865 157.915 107.735 157.189 108.506L155.139 110.68C154.573 111.279 153.61 111.356 152.947 110.854L152.247 110.324C151.568 109.811 150.58 109.904 150.022 110.533Z"
                fill="#818181"
            />
            <path
                d="M151 108C152.105 108 153 107.105 153 106C153 104.895 152.105 104 151 104C149.895 104 149 104.895 149 106C149 107.105 149.895 108 151 108Z"
                fill="#E66819"
            />
            <path
                d="M102 73C102 71.3431 103.343 70 105 70H131C132.657 70 134 71.3431 134 73V94C134 95.6569 132.657 97 131 97H105C103.343 97 102 95.6569 102 94V73Z"
                fill="#404040"
            />
            <path d="M108.978 78.5H134H108.978Z" fill="#404040" />
            <path
                d="M107 92H120"
                stroke="white"
                strokeWidth={2}
                strokeLinecap="round"
            />
            <path
                d="M128 92H129"
                stroke="#767676"
                strokeWidth={2}
                strokeLinecap="round"
            />
            <path
                d="M113.022 80.5332L110.376 83.519C109.505 84.5023 110.244 86 111.601 86H124.399C125.627 86 126.397 84.7455 125.786 83.7382L122.769 78.7599C122.227 77.8647 120.915 77.7355 120.189 78.5056L118.139 80.6797C117.573 81.2794 116.61 81.3559 115.947 80.8538L115.247 80.3241C114.568 79.8107 113.58 79.9035 113.022 80.5332Z"
                fill="#818181"
            />
            <path
                d="M114 78C115.105 78 116 77.1046 116 76C116 74.8954 115.105 74 114 74C112.895 74 112 74.8954 112 76C112 77.1046 112.895 78 114 78Z"
                fill="#E66819"
            />
            <path
                d="M102 103C102 101.343 103.343 100 105 100H131C132.657 100 134 101.343 134 103V124C134 125.657 132.657 127 131 127H105C103.343 127 102 125.657 102 124V103Z"
                fill="#404040"
            />
            <path d="M108.978 108.5H134H108.978Z" fill="#404040" />
            <path
                d="M113.022 110.533L110.376 113.519C109.505 114.502 110.244 116 111.601 116H124.399C125.627 116 126.397 114.745 125.786 113.738L122.769 108.76C122.227 107.865 120.915 107.735 120.189 108.506L118.139 110.68C117.573 111.279 116.61 111.356 115.947 110.854L115.247 110.324C114.568 109.811 113.58 109.904 113.022 110.533Z"
                fill="#818181"
            />
            <path
                d="M114 108C115.105 108 116 107.105 116 106C116 104.895 115.105 104 114 104C112.895 104 112 104.895 112 106C112 107.105 112.895 108 114 108Z"
                fill="#E66819"
            />
            <mask
                id="mask0_46_1400"
                style={{
                maskType: "luminance",
                }}
                maskUnits="userSpaceOnUse"
                x={29}
                y={13}
                width={141}
                height={50}
            >
                <path
                d="M165.645 13H33.3555C30.9522 13 29.0039 14.1813 29.0039 15.6385V60.3615C29.0039 61.8187 30.9522 63 33.3555 63H165.645C168.048 63 169.996 61.8187 169.996 60.3615V15.6385C169.996 14.1813 168.048 13 165.645 13Z"
                fill="white"
                />
            </mask>
            <g mask="url(#mask0_46_1400)">
                <path
                d="M165.644 13H33.3553C30.9519 13 29.0037 14.1813 29.0037 15.6385V60.3615C29.0037 61.8187 30.9519 63 33.3553 63H165.644C168.048 63 169.996 61.8187 169.996 60.3615V15.6385C169.996 14.1813 168.048 13 165.644 13Z"
                fill="#404040"
                />
                <path
                d="M50.3116 40.333L43.0345 47.7975C40.6379 50.2558 42.672 54 46.404 54H81.598C84.975 54 87.0906 50.8637 85.4121 48.3456L77.1152 35.8998C75.6232 33.6617 72.0173 33.3387 70.0198 35.2641L64.3815 40.6993C62.8263 42.1986 60.1774 42.3898 58.353 41.1344L56.4285 39.8102C54.5633 38.5267 51.8462 38.7589 50.3116 40.333Z"
                fill="#818181"
                />
                <path
                d="M55.4998 31C58.5373 31 60.9998 28.5376 60.9998 25.5C60.9998 22.4624 58.5373 20 55.4998 20C52.4622 20 49.9998 22.4624 49.9998 25.5C49.9998 28.5376 52.4622 31 55.4998 31Z"
                fill="#E66819"
                />
                <path d="M179.352 13H98.4119V63H179.352V13Z" fill="white" />
                <path
                d="M109.073 29.0952H134.095"
                stroke="#404040"
                strokeWidth={2}
                strokeLinecap="round"
                />
                <path
                d="M109.073 35H148.673"
                stroke="#B7B7B7"
                strokeWidth={2}
                strokeLinecap="round"
                />
                <path
                d="M128.003 41H140.187"
                stroke="#B7B7B7"
                strokeWidth={2}
                strokeLinecap="round"
                />
                <path
                d="M109.073 41H122.998"
                stroke="#B7B7B7"
                strokeWidth={2}
                strokeLinecap="round"
                />
                <path
                d="M130.276 48H108.724C107.772 48 107 48.584 107 49.3043V52.6957C107 53.416 107.772 54 108.724 54H130.276C131.228 54 132 53.416 132 52.6957V49.3043C132 48.584 131.228 48 130.276 48Z"
                fill="#E66819"
                />
                <path d="M114 51H124.668" stroke="white" strokeLinecap="round" />
                <path
                d="M157.276 48H135.724C134.772 48 134 48.584 134 49.3043V52.6957C134 53.416 134.772 54 135.724 54H157.276C158.228 54 159 53.416 159 52.6957V49.3043C159 48.584 158.228 48 157.276 48Z"
                fill="#767676"
                />
                <path d="M141 51H151.668" stroke="white" strokeLinecap="round" />
            </g>
            <g clipPath="url(#clip1_46_1400)">
                <path
                d="M164.237 22.0378L162.655 23.4029L163.137 25.4444C163.163 25.5552 163.156 25.6715 163.117 25.7784C163.078 25.8853 163.007 25.9782 162.915 26.0452C162.823 26.1123 162.713 26.1505 162.599 26.1551C162.485 26.1596 162.373 26.1303 162.275 26.0709L160.5 24.9783L158.724 26.0709C158.626 26.13 158.514 26.159 158.4 26.1543C158.286 26.1495 158.177 26.1113 158.085 26.0443C157.993 25.9773 157.923 25.8846 157.883 25.7779C157.844 25.6711 157.837 25.5551 157.863 25.4444L158.347 23.4029L156.765 22.0378C156.679 21.9634 156.617 21.8654 156.586 21.7559C156.555 21.6464 156.558 21.5303 156.593 21.4221C156.628 21.3139 156.694 21.2184 156.783 21.1475C156.872 21.0766 156.979 21.0335 157.093 21.0235L159.167 20.8562L159.967 18.9198C160.01 18.8142 160.084 18.724 160.179 18.6604C160.274 18.5969 160.385 18.563 160.499 18.563C160.613 18.563 160.725 18.5969 160.819 18.6604C160.914 18.724 160.988 18.8142 161.031 18.9198L161.831 20.8562L163.905 21.0235C164.019 21.0331 164.127 21.076 164.216 21.1468C164.305 21.2176 164.372 21.3131 164.407 21.4214C164.442 21.5298 164.444 21.6461 164.414 21.7558C164.383 21.8655 164.321 21.9637 164.235 22.0381L164.237 22.0378Z"
                fill="#E66819"
                />
            </g>
            </g>
            <defs>
            <clipPath id="clip0_46_1400">
                <rect width={200} height={117} fill="white" />
            </clipPath>
            <clipPath id="clip1_46_1400">
                <rect width={9} height={9} fill="white" transform="translate(156 18)" />
            </clipPath>
            </defs>
        </svg>
    )
}

export default Single;